// extracted by mini-css-extract-plugin
export default {"premintPreviewAssetContainer":"CandyMachinePreviewAssetMarquee_premintPreviewAssetContainer__WBtY3","marquee":"CandyMachinePreviewAssetMarquee_marquee__spNgk"};